import Vue from 'vue';
import { Component, Prop, Provide, Watch, Inject } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import StageHeader from '../../components/stageHeader';
import Datepicker from 'vuejs-datepicker';
import TmsDatepicker from '../../components/tmsDatepicker';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './billoflading.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import { Validator } from 'vee-validate';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import Moment from 'moment';
import { map, partialRight, pick, filter } from 'lodash-es';

import qs from 'qs';
import tmsService from '../../services/axios/tmsService';
@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        Datepicker,
        TmsDatepicker,
    },
})
export default class Billoflading extends Vue {
    truckloadForm: any = {};
    ssds: any = '02';
    aaa: any = '02';
    ssd: any = '02';
    ssde: any = { id: '01', name: '01010101' };
    datas = ['01', '02', '03'];
    truckloadFormdata: Array<any> = [
        { id: '01', name: '01010101' },
        { id: '02', name: '02020202' },
        { id: '03', name: '03030303' },
    ];
    bol: any = {
        commodity_type_of_package: 'pallets',
    };
    orderInfo: any = {};
    validationStarted: Boolean = false;
    classArr: any = [
        { label: '0', value: '0' },
        { label: '50', value: '50' },
        { label: '55', value: '55' },
        { label: '60', value: '60' },
        { label: '65', value: '65' },
        { label: '70', value: '70' },
        { label: '77', value: '77' },
        { label: '85', value: '85' },
        { label: '92', value: '92' },
        { label: '100', value: '100' },
        { label: '110', value: '110' },
        { label: '125', value: '125' },
        { label: '150', value: '150' },
        { label: '175', value: '175' },
        { label: '200', value: '200' },
        { label: '250', value: '250' },
        { label: '300', value: '300' },
        { label: '400', value: '400' },
        { label: '500', value: '500' },
    ];
    editProductModal: string = 'createResultShow';
    errorText: any = '';
    showErrTip: Boolean = false;
    disabledDates: any = {
        to: new Date(Date.now() - 8640000),
    };

    @Inject() $validator: Validator;

    created() {
        this.getOrderDetail();
    }

    editProductAction(index: any) {
        this.$modal.show(this.editProductModal);
    }
    closeModal() {
        this.$modal.hide(this.editProductModal);
    }

    getOrderDetail() {
        let orderId = this.$route.params.orderId;
        if (orderId) {
            tmsServiceBackend.get(`/tms/order/${orderId}/bol/detail`).then(
                (res: any) => {
                    this.orderInfo = res.data.data;
                    this.bol.tms_order_group_id = this.orderInfo.fk_tms_order_group_id;
                    this.bol.tms_order_id = this.orderInfo.fk_tms_order_id;
                    this.bol.tms_order_pro = this.orderInfo.tms_order_pro;
                },
                (err: any) => {
                    this.err(err.response.data.statusText);
                }
            );
        }
    }

    changeCheck() {
        let checkArr = [
            'shipper_liftgate',
            'consignee_liftgate',
            'third_party_liftgate',
            'shipper_inside_pickup',
            'consignee_inside_pickup',
            'third_party_inside_pickup',
            'is_hazardous_masterials',
        ];
        checkArr.forEach(item => {
            if (this.bol[item]) {
                this.bol[item] = 1;
            } else {
                this.bol[item] = 0;
            }
        });
    }

    async create() {
        this.validationStarted = true;
        this.$validator.validateAll().then(res => {
            this.validateErrors(this);
            if (res) {
                this.changeCheck();
                this.createBol();
            }
        });
    }

    createBol() {
        let manifests = map(this.orderInfo.manifests, partialRight(pick, ['id', 'nmfc']));
        let nmfcs = filter(manifests, 'nmfc');
        tmsServiceBackend
            .post(`/cpv2/TmsManifest/update`, qs.stringify({ manifest_lines: nmfcs }))
            .then(
                (res: any) => {},
                (err: any) => {
                    this.err(err.response.data.statusText);
                }
            );

        this.bol.tms_order_bol_date = Moment(this.bol.tms_order_bol_date).format('YYYY-MM-DD');
        tmsServiceBackend.post(`/tms/order/bol`, qs.stringify(this.bol)).then(
            (res: any) => {
                this.createBolPDF();
                this.$modal.show(this.editProductModal);
            },
            (err: any) => {
                this.err(err.response.data.statusText);
            }
        );
    }

    createBolPDF() {
        let orderId = this.$route.params.orderId;
        if (orderId) {
            const bolFileData = {
                order_id: this.orderInfo.fk_tms_order_id,
                is_preview: false,
                sign_img: '',
                order: {
                    date: this.bol.tms_order_bol_date,
                    bol: '',
                    pro: '',
                    scac_code: '',
                    so: '',
                    order_ref: '',
                    po: '',
                    pu: this.bol.tms_order_group_id,
                    quote: this.orderInfo.tms_quote_id,
                },
                shipper: {
                    name: this.orderInfo.shipper.location_name,
                    street: this.orderInfo.shipper.location_street,
                    city: this.orderInfo.shipper.location_city,
                    state: this.orderInfo.shipper.location_state,
                    zip: this.orderInfo.shipper.location_zip,
                    contact: this.orderInfo.shipper.location_contact,
                    email: this.orderInfo.shipper.location_email,
                    phone: this.orderInfo.shipper.location_phone,
                },
                consignee: {
                    name: this.orderInfo.consignee.location_name,
                    street: this.orderInfo.consignee.location_street,
                    city: this.orderInfo.consignee.location_city,
                    state: this.orderInfo.consignee.location_state,
                    zip: this.orderInfo.consignee.location_zip,
                    contact: this.orderInfo.consignee.location_contact,
                    email: this.orderInfo.consignee.location_email,
                    phone: this.orderInfo.consignee.location_phone,
                },
                freight: {
                    collect_or: false,
                    '3rd_party': false,
                    master_bill: false,
                },
                cod: {
                    cod_amount: '',
                    cashier_check: false,
                    company_check: false,
                    cod_prepaid: false,
                    cod_collect: false,
                },
                bill: {
                    name: '',
                    street: '',
                    phone: '',
                },
                special: {
                    bill_to: false,
                    remit_code_to: false,
                    customs_broker: false,
                    guaranteed_am: false,
                    guaranteed_5pm: false,
                    liftgate: false,
                    inside: false,
                    appointment: false,
                    residential: false,
                    sort_seg: false,
                },
                manifest: this.orderInfo.manifests.map(function(item: any, k: number) {
                    return {
                        units: k + 1,
                        package_type: '',
                        desc: item.content,
                        weight: item.weight,
                        nmfc: item.nmfc,
                        class: item.class,
                    };
                }),
                manifest_total: {
                    units: this.orderInfo.manifests.length,
                    pallets: '',
                    cubic: '',
                    weight: this.orderInfo.manifests.reduce(
                        (accumulator: any, currentItem: any) =>
                            accumulator + parseFloat(currentItem.weight),
                        0
                    ),
                },
                other: {
                    mark_x: '',
                    carrier_name: '',
                    trailer: '',
                    tractor: '',
                    seal: '',
                    license: '',
                    shipper_load_count_yes: '',
                    shipper_load_count_no: '',
                    pallets_count: '',
                    units_count: '',
                    pickup_pcs: '',
                    pickup_driver: '',
                    delivery_driver: '',
                    pickup_date: '',
                    deliver_date: '',
                    shipper_signature: '',
                    consignee_signature: '',
                    received_pcs: '',
                },
            };
            tmsService.post(`/api/createFiles/bolPdf.php`, qs.stringify(bolFileData)).then(
                (res: any) => {},
                (err: any) => {
                    this.err(err.response.data.statusText);
                }
            );
        }
    }

    goBolDetailPage() {
        this.$router.replace({
            name: 'Bol',
            params: {
                id: this.$route.params.orderId,
            },
        });
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.err(errText);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/billoflading/index.ts